



























































import {Component, Prop, Vue} from 'vue-property-decorator';
import {Order} from '@/interfaces/order.interface';
import {namespace} from 'vuex-class';
import {OrderDocument} from '@/interfaces/document.interface';
import PermissionsService from '../services/permissions.service';
import FileDropZone from '@/components/FileDropZone.vue';

const ordersModule = namespace('orders');

@Component({
  components: {
    FileDropZone
  }
})
export default class OrderDetailsDocuments extends Vue {
  @Prop({default: []}) order!: Order;
  @ordersModule.Action fetchDocuments!: any;
  @ordersModule.Action createDocument!: any;
  @ordersModule.Action deleteDocumentWithConfirmation: any;

  mounted() {
    this.fetchDocuments({orderUuid: this.order.uuid});
  }

  async handleUpload(): Promise<any> {
    // @ts-ignore
    // noinspection TypeScriptUnresolvedVariable
    const file: any = this.$refs.file.files[0];
    return await this.createDocument({orderUuid: this.order.uuid!, document: {file}});
  }

  get files(): any[] {
    const orderDocuments = this.order.documents || [];
    return orderDocuments.sort((a, b) => new Date(a.createdAt!) > new Date(b.createdAt!) ? -1 : 1);
  }

  getIconClass(document: OrderDocument): string {
    return 'amber white--text';
  }

  getIcon(document: OrderDocument): string {
    const type = document.type;
    if (type === 'application/pdf') return 'picture_as_pdf';
    return 'insert_drive_file';
  }

  triggerFilePicker(): void {
    // @ts-ignore
    // noinspection TypeScriptUnresolvedFunction
    this.$refs.file.click();
  }

  del(document: OrderDocument) {
    this.deleteDocumentWithConfirmation({document});
  }

  get canCreateDocuments(): boolean {
    return PermissionsService.can('documents', 'create');
  }

  get canDeleteDocuments(): boolean {
    return PermissionsService.can('documents', 'delete');
  }

  canDeleteOwnDocument(doc: OrderDocument): boolean {
    return PermissionsService.can('documents', 'delete:own', undefined, doc.userUuid);
  }

  async uploadFiles(files: File[]) {
    if (files && files.length) {
      for (let i = 0; i < files.length; i++) {
        await this.createDocument({orderUuid: this.order.uuid!, document: {file: files[i]}});
      }
    }
  }
}
